import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import Button from '../components/Button';

export default function Register(){
  const { register: registerUser, login } = useAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState('');
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    if (password.length > 30) { 
      setError('Password must be 30 characters or fewer.'); 
      return; 
    }
    setLoading(true);
    try {
      await registerUser(email, password, username);
      await login(email, password);
      navigate('/games', { replace: true });
    } catch (err) {
      setError(err.message || 'Registration failed.');
    } finally {
      setLoading(false);
    }
  };

  return (


<>


        <div className="spacer" style={{height: 20}}></div>



    <div className="mx-auto max-w-lg bg-slate-900/70 border border-slate-800 rounded-2xl p-6 shadow-xl shadow-emerald-500/10">
      <h1 className="text-2xl font-bold mb-4">Create account</h1>
      <form onSubmit={handleSubmit} className="grid gap-3">
        <label className="grid gap-1">
          <span className="text-sm text-slate-300">Username</span>
          <input
            className="border border-slate-700 bg-slate-950/60 rounded-xl px-3 py-2 text-sm text-slate-100 placeholder:text-slate-500 focus:outline-none focus:ring-2 focus:ring-emerald-500 focus:border-emerald-500"
            type="text"
            value={username}
            onChange={(e) => setUsername(e.target.value)}
            required
          />
        </label>
        <label className="grid gap-1">
          <span className="text-sm text-slate-300">Email</span>
          <input
            className="border border-slate-700 bg-slate-950/60 rounded-xl px-3 py-2 text-sm text-slate-100 placeholder:text-slate-500 focus:outline-none focus:ring-2 focus:ring-emerald-500 focus:border-emerald-500"
            type="email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            required
          />
        </label>
        <label className="grid gap-1">
          <span className="text-sm text-slate-300">
            Password <span className="text-slate-500">(max 30 chars)</span>
          </span>
          <input
            className="border border-slate-700 bg-slate-950/60 rounded-xl px-3 py-2 text-sm text-slate-100 placeholder:text-slate-500 focus:outline-none focus:ring-2 focus:ring-emerald-500 focus:border-emerald-500"
            type="password"
            maxLength={30}
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            required
          />
        </label>
        {error && <div className="text-red-400 text-sm">{error}</div>}
        <Button disabled={loading} className="bg-emerald-500 text-grey hover:bg-emerald-400">
          {loading ? 'Creating…' : 'Create account'}
        </Button>
      </form>
      <div className="text-sm mt-3 text-slate-300">
        Already have an account?{' '}
        <Link to="/login" className="text-emerald-300 underline">
          Sign in
        </Link>
      </div>
    </div>

</>

  );
}
